var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "base-modal-ex",
    {
      attrs: {
        active: _vm.isActive,
        "animation-in": _vm.animationIn,
        "animation-out": _vm.animationOut,
        "animation-duration": _vm.animationDuration,
        "can-cancel": false,
        "has-modal-card": "",
      },
      on: {
        "update:active": function ($event) {
          _vm.isActive = $event
        },
      },
    },
    [
      _c("div", { staticClass: "model-content" }, [
        _c("div", { staticClass: "modal-card" }, [
          _c("header", { staticClass: "modal-card-head" }, [
            _c(
              "p",
              {
                staticClass: "modal-card-title",
                class: { "is-flex-items-center": _vm.showIcon },
              },
              [
                _vm.showIcon
                  ? _c(
                      "span",
                      {
                        staticClass: "icon is-medium",
                        class: `has-text-${_vm.iconType}`,
                        staticStyle: { "margin-right": "0.5rem" },
                      },
                      [
                        _c("i", {
                          staticClass: "mdi mdi-36px",
                          class: `${_vm.iconName}`,
                        }),
                      ]
                    )
                  : _vm._e(),
                _vm._t("text-title"),
              ],
              2
            ),
          ]),
          _c(
            "section",
            { staticClass: "modal-card-body" },
            [_vm._t("text-content")],
            2
          ),
          _c("footer", { staticClass: "modal-card-foot" }, [
            _c(
              "div",
              {
                staticClass: "columns is-gapless",
                staticStyle: { width: "100%" },
              },
              [
                _c("div", { staticClass: "column" }, [
                  _c(
                    "button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showReload,
                          expression: "showReload",
                        },
                      ],
                      staticClass: "button is-warning tooltip",
                      attrs: { "data-tooltip": "Reload data" },
                      on: {
                        click: function ($event) {
                          return _vm.reload()
                        },
                      },
                    },
                    [_vm._v("Reload")]
                  ),
                ]),
                _c(
                  "div",
                  {
                    staticClass: "column",
                    style: `display: flex; justify-content: flex-${_vm.buttonLocation}`,
                  },
                  [
                    _c(
                      "button",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.showOverwrite,
                            expression: "showOverwrite",
                          },
                        ],
                        staticClass: "button is-primary tooltip",
                        attrs: { "data-tooltip": "Overwrite & Save data" },
                        on: {
                          click: function ($event) {
                            return _vm.overwrite()
                          },
                        },
                      },
                      [_vm._v("Overwrite & Save")]
                    ),
                    _c(
                      "button",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.showMerge,
                            expression: "showMerge",
                          },
                        ],
                        staticClass: "button is-primary tooltip",
                        attrs: { "data-tooltip": "Merge & Save data" },
                        on: {
                          click: function ($event) {
                            return _vm.merge()
                          },
                        },
                      },
                      [_vm._v("Merge & Save")]
                    ),
                    _c(
                      "button",
                      {
                        staticClass: "button tooltip",
                        attrs: { "data-tooltip": "Don't continue" },
                        on: {
                          click: function ($event) {
                            return _vm.close()
                          },
                        },
                      },
                      [_vm._v("Cancel")]
                    ),
                  ]
                ),
              ]
            ),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }